var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightmodeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 49,
    viewBox: "0 0 61 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5199_234570)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69727 0.0300619H11.8107L11.5979 8.3571C20.3468 8.90544 23.2002 10.303 30.2176 15.5438C35.8567 11.3706 41.8344 8.40563 49.0308 8.36195L49.0211 -0.00390625L51.1733 0.0252093L51.033 7.82817C50.9895 10.1671 50.7187 10.0167 48.4408 10.3224C40.2626 11.4239 37.119 12.4721 30.3434 18.2467C23.65 13.1951 20.0131 10.8902 12.1589 10.3612C9.66341 10.1914 9.37807 10.0652 9.55218 8.00286L9.69243 0.0252093L9.69727 0.0300619Z",
    fill: "url(#paint0_linear_5199_234570)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91309 4.70312H7.02654L7.10392 9.09957C7.32156 13.4281 11.002 12.5837 13.7441 13.001C21.8885 14.2433 24.7612 16.7764 30.5793 22.2161C36.1458 15.1216 42.8489 13.2194 51.4333 12.6323C52.6521 12.5498 53.6484 10.8465 53.6677 9.71585L53.7644 4.76136L55.9166 4.79047L55.6941 9.6285C55.5732 12.2101 53.7257 14.6946 51.0368 14.8547C41.0837 15.4613 36.2667 18.2758 30.5164 25.545C24.916 19.1007 20.9115 15.6457 11.9886 14.9615C8.39038 14.9566 5.20326 13.86 5.07268 9.71585L4.91309 4.70312Z",
    fill: "url(#paint1_linear_5199_234570)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.32841L2.47134 9.29929C2.76636 13.2105 5.09261 17.1071 9.74996 17.3886C18.4311 17.9126 25.8596 21.0862 29.5691 29.5297L30.2945 31.1747H30.7298C31.0683 30.0392 31.3295 29.4909 31.8711 28.4379C36.3302 21.1978 41.9016 17.7865 50.4763 17.5438C55.3126 16.9906 57.8807 14.3799 58.3885 9.23621L60.8163 9.2168C60.2505 14.3994 56.8506 19.4363 51.342 19.9653C49.0738 20.1788 47.3956 20.1254 45.0742 20.7271C39.9332 22.0664 35.8369 25.2934 33.264 30.6167C32.0356 33.3778 31.5423 35.2946 31.5036 38.3226L29.3224 38.2886C29.1096 35.1393 28.7469 32.1356 26.943 29.4327C21.7391 21.6443 18.2618 20.6252 9.50331 19.7226C3.24999 19.0773 0.836678 14.7245 0.00967258 9.32355L0 9.32841Z",
    fill: "url(#paint2_linear_5199_234570)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4447 6.71289C33.1482 6.71289 35.7356 7.22726 38.1054 8.16381L34.6571 9.70208L34.6426 9.75546C33.2933 9.44004 31.8859 9.2702 30.4399 9.2702C29.076 9.2702 27.7461 9.42063 26.4693 9.70208L22.9098 8.11044C25.2457 7.20785 27.7847 6.71289 30.4399 6.71289H30.4447ZM50.7136 22.3285C51.173 24.0609 51.4197 25.8806 51.4197 27.7634C51.4197 39.3854 42.0276 48.8091 30.4447 48.8091C18.8618 48.8091 9.46973 39.3854 9.46973 27.7634C9.46973 25.8806 9.71638 24.056 10.1807 22.3188L12.8019 22.4256C12.2941 24.1143 12.0233 25.9049 12.0233 27.7586C12.0233 37.9684 20.274 46.2469 30.4495 46.2469C40.6251 46.2469 48.8758 37.9684 48.8758 27.7586C48.8758 25.9049 48.605 24.1191 48.0972 22.4353L50.7184 22.3285H50.7136Z",
    fill: "url(#paint3_linear_5199_234570)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2839 24.3457C43.2512 25.1706 43.8654 26.4032 43.8654 27.7765C43.8654 30.261 41.8583 32.2797 39.3773 32.2797C38.0135 32.2797 36.7899 31.6683 35.9629 30.6977L37.3993 28.8343C37.7765 29.538 38.5213 30.0184 39.3725 30.0184C40.6106 30.0184 41.6117 29.0139 41.6117 27.7716C41.6117 26.9127 41.1329 26.1703 40.4268 25.7918L42.2791 24.3457H42.2839Z",
    fill: "url(#paint4_linear_5199_234570)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6196 24.3457C17.6523 25.1706 17.0381 26.4032 17.0381 27.7765C17.0381 30.261 19.0451 32.2797 21.5262 32.2797C22.8948 32.2797 24.1136 31.6683 24.9406 30.6977L23.5042 28.8343C23.127 29.538 22.3822 30.0184 21.531 30.0184C20.2929 30.0184 19.2918 29.0139 19.2918 27.7716C19.2918 26.9127 19.7706 26.1703 20.4767 25.7918L18.6244 24.3457H18.6196Z",
    fill: "url(#paint5_linear_5199_234570)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5199_234570",
    x1: 55.1462,
    y1: 9.12139,
    x2: 3.371,
    y2: 9.12142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E0047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912799,
    stopColor: "#FB00A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5199_234570",
    x1: 60.7803,
    y1: 15.1241,
    x2: -2.60322,
    y2: 15.1241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E0047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912799,
    stopColor: "#FB00A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5199_234570",
    x1: 66.6158,
    y1: 23.7697,
    x2: -8.96241,
    y2: 23.7698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E0047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912799,
    stopColor: "#FB00A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5199_234570",
    x1: 55.4201,
    y1: 27.761,
    x2: 3.28762,
    y2: 27.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E0047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912799,
    stopColor: "#FB00A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5199_234570",
    x1: 44.619,
    y1: 28.3127,
    x2: 34.7983,
    y2: 28.3127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E0047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912799,
    stopColor: "#FB00A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5199_234570",
    x1: 25.6942,
    y1: 28.3127,
    x2: 15.8735,
    y2: 28.3127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E0047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912799,
    stopColor: "#FB00A1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5199_234570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.8163,
    height: 48.8032,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightmodeLogo);
export default __webpack_public_path__ + "static/media/lightmodeLogo.01ba45339d92c266581f1c1595f838af.svg";
export { ForwardRef as ReactComponent };